// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__3I60g","active":"breadcrumbs_active__3t5Ny"};